import { PropTypes } from 'prop-types';

const NoDataAvailable = ({ label }) => (
	<div className="alert-info alert mt-3">
		<i aria-hidden="true" className="ddc-icon ddc-icon-alert align-left" />
		{label}
	</div>
);

NoDataAvailable.propTypes = {
	label: PropTypes.string.isRequired
};

export default NoDataAvailable;
